import { Application } from 'pixi.js';

import { OVERLAY_HEIGHT, OVERLAY_WIDTH } from '../game/config';

export async function createPixiApp(): Promise<Application> {
  const app = new Application();
  const search = new URLSearchParams(window.location.search);
  const forceCanvas = search.get('renderer') === 'canvas' || window.navigator.webdriver === true;

  await app.init({
    width: OVERLAY_WIDTH,
    height: OVERLAY_HEIGHT,
    background: '#10160f',
    antialias: false,
    autoDensity: true,
    resolution: Math.min(window.devicePixelRatio || 1, 2),
    preference: forceCanvas ? 'canvas' : 'webgl',
  });

  app.canvas.dataset.streamKingdomsRenderer = 'pixi';
  document.body.style.margin = '0';
  document.body.style.overflow = 'hidden';
  document.body.style.background = '#050704';

  return app;
}
